import { Component } from '@angular/core';
import { HttpService } from '../service/http.service';
import { AgentCommissionListItem } from '../agent-commission-list-item';
import Decimal from 'decimal.js';
import { environment } from 'src/environments/environment';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { BookingCommissionForm } from '../form-template/booking-commission-form';
import { ToastMessageService } from '../toast-message.service';
import { ApiError } from '../api-error';
import { Router } from '@angular/router';

@Component({
  selector: 'app-agent-commissions-update',
  templateUrl: './agent-commissions-update.component.html',
  styleUrls: ['./agent-commissions-update.component.css']
})
export class AgentCommissionsUpdateComponent {

  ONE_HUNDRED: Decimal = new Decimal(100);
  BRUGES_INVOICE_RATE: Decimal = new Decimal(0.85);
  commissions: AgentCommissionListItem[] = [];
  commissionRate: number = 40;
  baseUrl: string = environment.lvConnectBaseUrl;
  formArray: FormArray<FormGroup<BookingCommissionForm>>;
  parentForm: FormGroup;

  constructor(
    private httpService: HttpService,
    private builder: FormBuilder,
    private toastService: ToastMessageService,
    private router: Router
  ) {
    this.formArray = builder.array<FormGroup<BookingCommissionForm>>([]);
    this.parentForm = builder.group({items: this.formArray});
    httpService.getSalesAgentCommissions().subscribe((res: AgentCommissionListItem[]) => {
      this.commissions = res;
      for (let commission of this.commissions) {
        commission.commissionStr = new Decimal(commission.grossMargin).times(new Decimal(this.commissionRate).div(this.ONE_HUNDRED)).toFixed(2);
        if (commission.totalSchoolInvoice == 0) {
          commission.info = "School Invoice missing";
        }
        this.formArray.push(builder.group<BookingCommissionForm>({
          bookingId: new FormControl(commission.bookingId),
          isCommissionPaid: new FormControl(commission.isCommissionPaid)
        }));
      }
    });
  }

  isCommissionPaidChange(bookingId: number, val: boolean){
    this.httpService.updateAgentCommissionPaidStatus(bookingId, val).subscribe(() => {
      this.toastService.addSuccess("Success", "Record Updated");
    }, error => this.toastService.addApiError(new ApiError(error)));
  }

  goToViewMode(){
    this.router.navigate(["/management/agent-commission"]);
  }

}
